import React, { useEffect } from "react";
import { X, CheckCircle, AlertCircle, Info } from "lucide-react";

export const Toast = ({
  message,
  type = "success",
  onClose,
  duration = 3000,
  action,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const icons = {
    success: <CheckCircle className="w-5 h-5 text-green-500" />,
    error: <AlertCircle className="w-5 h-5 text-red-500" />,
    info: <Info className="w-5 h-5 text-blue-500" />,
  };

  const bgColors = {
    success: "bg-white border-green-500",
    error: "bg-white border-red-500",
    info: "bg-white border-blue-500",
  };

  const textColors = {
    success: "text-green-700",
    error: "text-red-700",
    info: "text-blue-700",
  };

  const handleAction = () => {
    if (action?.onClick) {
      action.onClick();
    } else if (action?.path) {
      window.location.href = action.path;
    }
    onClose();
  };

  return (
    <div
      className={`fixed top-20 right-4 z-[9999] flex items-center gap-3 px-4 py-3 rounded-lg border-2 shadow-xl ${bgColors[type]} animate-slideIn min-w-[320px]`}
    >
      <div className={textColors[type]}>{icons[type]}</div>
      <div className="flex-1">
        <p className={`text-sm font-semibold ${textColors[type]}`}>{message}</p>
        {action && (
          <button
            onClick={handleAction}
            className={`mt-2 text-xs font-bold ${textColors[type]} underline hover:no-underline`}
          >
            {action.label}
          </button>
        )}
      </div>
      <button
        onClick={onClose}
        className="ml-2 hover:opacity-70 transition-opacity"
      >
        <X className="w-4 h-4 text-gray-600" />
      </button>
    </div>
  );
};

export const ToastContainer = ({ toasts, removeToast }) => {
  return (
    <div className="fixed top-20 right-4 z-[9999] space-y-2">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => removeToast(toast.id)}
          duration={toast.duration}
          action={toast.action}
        />
      ))}
    </div>
  );
};
